<template>
    <div id="system_app">
        <div class="all-main">
            <router-view />
        </div>

        <van-tabbar v-model="active" v-show="show">
            <van-tabbar-item v-if="leader" replace to="ldSystem" icon="calendar-o">
                领导值班
            </van-tabbar-item>
            <van-tabbar-item v-if="fdy" replace to="fdySystem" icon="newspaper-o">
                辅导员值班
            </van-tabbar-item>
            <van-tabbar-item v-if="bwc" replace to="bwcSystem" icon="cashier-o">
                保卫部值班
            </van-tabbar-item>

            <van-tabbar-item replace to="index" icon="desktop-o">
                前端管理
            </van-tabbar-item>
        </van-tabbar>

    </div>
</template>
<script>
export default {
    data: function () {
        return {
            active: 0,
            show: true,

            leader: false,
            fdy: false,
            bwc: false,
        };
    },
    watch: {
        $route(to, from) {
            console.log(to, from);
        },
        '$store.getters.active': function () {
            this.active = this.$store.getters.active;
        }
    },
    mounted() {
        console.log(this.$route);
        if (this.$route.path == "/404") {
            this.show = false;
        }
        else {
            this.show = true;
        }
        this.active = this.$store.getters.active;
        console.log(this.active, 'active');


        const auth = this.$store.getters.abpConfig.auth.grantedPolicies;

        this.leader = auth['SchedulingModule.Leader'];
        this.bwc = auth['SchedulingModule.BWC'];
        this.fdy = auth['SchedulingModule.FDY'];
    },

}
</script>
<style lang="scss">
#app,
.app,
html,
body {
    width: 100%;
    height: 100vh;
    padding: 0px;
    margin: 0px;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    overflow: hidden;
}

.all-main {
    flex: 1;
    height: calc(100vh - 38px);
    overflow: hidden;
}

#app {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    overflow-y: auto;
}

#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}

.van-tabbar--fixed {
    position: inherit !important;
}
</style>
